import _ from 'lodash';
import { guid } from '@/mixins/guid';
import { ASSETS } from '@/constants';
import { getDynamicData } from './item-types';
import { defaultItem } from './new-item';

const image = color => ({
  _id: guid.methods.guid(),
  altText: false,
  src: `${ASSETS}mock-images/default-images/product-feature/t-shirt-mock-${color}.svg`,
});

export function defaultProduct() {
  const data = getDynamicData({ type: 'products' }).itemData;
  const product = defaultItem();
  _.forOwn(data, (type, key) => {
    product[key] = type.value;
  });
  product.name = 'Product Name Here';
  product.description = 'Product description here.';
  product.extraImages = [image('blue'), image('purple'), image('red')];
  return product;
}



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/placeholders.js